import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * عند الانتقال بين الصفحات (مثلاً من السايدبار) يُرجع التمرير لأعلى الصفحة
 * حتى تظهر بداية الصفحة الجديدة وليس نفس موقع الـ scroll السابق.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
